import cloneDeep from 'lodash/cloneDeep'
import { apolloProvider } from '@/apollo-provider.js'
import { HIGHLIGHTED_SALE_PRODUCTS } from './graphql'

export default {
  setDraggedObject({ state, commit }, object) {
    commit('SET_OBJECT', { name: 'draggedObject', data: object, state })
    commit('SET_OBJECT', { name: 'isDraggingObject', data: true, state })
  },
  unsetDraggedObject({ state, commit }) {
    commit('SET_OBJECT', { name: 'draggedObject', data: {}, state })
    commit('SET_OBJECT', { name: 'isDraggingObject', data: false, state })
  },
  async fetchHighlightedOffers({ commit }, { app_units, activatable, franchise }) {
    await apolloProvider.defaultClient
      .query({
        query: HIGHLIGHTED_SALE_PRODUCTS,
        variables: {
          app_units: app_units,
          activatable: activatable,
          ...(franchise && { franchise }),
        },
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
      })
      .then(({ data }) => {
        commit('SET_HIGHLIGHTED_OFFERS', data.highlightedSalesProducts.highlightedSalesProducts)
      })
  },
  addHighlightedOffer({ state, commit }, item) {
    const highlightedItems = cloneDeep(state.highlightedOffers)
    highlightedItems.push(item)
    commit('SET_HIGHLIGHTED_OFFERS', highlightedItems)
  },
  removeHighlightedOffer({ state, commit }, { position, offerId }) {
    const highlightedItems = cloneDeep(state.highlightedOffers)
    highlightedItems.splice(position, 1)
    commit('SET_HIGHLIGHTED_OFFERS', highlightedItems)
  },
  rearrangeHighlightedOffer({ state, commit }, { item, newPosition, oldPosition }) {
    const highlightedItems = cloneDeep(state.highlightedOffers)
    highlightedItems.splice(oldPosition, 1)
    highlightedItems.splice(newPosition, 0, item)
    commit('SET_HIGHLIGHTED_OFFERS', highlightedItems)
  },
}
